import { useState, useEffect } from 'react'
import apiClient from '../../services/apiClient'
import Layout from '../../components/Layout'
import AdminTabs from '../../components/AdminTabs'
import CrudTable from '../../components/CrudTable'
import Spinner from '../../components/Spinner'

export default function AdminTools() {
  const [items, setItems]     = useState([])
  const [loading, setLoading] = useState(true)
  const load = () => {
    setLoading(true)
    apiClient.get('/admin/ai-tools?include_inactive=true').then((r) => setItems(r.data.items)).finally(() => setLoading(false))
  }
  useEffect(() => { load() }, [])

  return (
    <Layout>
      <div className="page-header">
        <h1 className="page-title">Admin</h1>
      </div>
      <AdminTabs />
      {loading ? (
        <div className="loading-state"><Spinner size="md" /> Loading…</div>
      ) : (
        <div className="card">
        <CrudTable
          items={items}
          columns={[
            { key: 'id',        label: 'ID' },
            { key: 'name',      label: 'Name', editable: true },
            { key: 'is_active', label: 'Active', editable: true, type: 'boolean' },
          ]}
          newItemFields={[{ key: 'name', label: 'Name' }]}
          onCreate={async (data) => { await apiClient.post('/admin/ai-tools', data); load() }}
          onUpdate={async (id, data) => { await apiClient.put(`/admin/ai-tools/${id}`, { name: data.name, is_active: Number(data.is_active) }); load() }}
          onDelete={async (id) => { await apiClient.delete(`/admin/ai-tools/${id}`); load() }}
        />
        </div>
      )}
    </Layout>
  )
}

